/** List-row terminationRuleSetId keyed by plan id — set on Edit from table before compose fetch (fetch only passes `id`). */
const byPlanId = new Map<string, string>();

export function setPlanListTerminationRuleSetId(planId: string, terminationRuleSetId: string): void {
  const pid = String(planId ?? '').trim();
  const setId = String(terminationRuleSetId ?? '').trim();
  if (!pid || !setId) return;
  byPlanId.set(pid, setId);
}

export function getPlanListTerminationRuleSetId(planId: string): string {
  return byPlanId.get(String(planId ?? '').trim()) ?? '';
}

export function clearPlanListTerminationRuleSetId(planId: string): void {
  byPlanId.delete(String(planId ?? '').trim());
}
